
import { IClient } from "../../types/Client/IClient";
import { IProject } from "../../types/Project/IProject";
import { baseApi } from "./baseApi";

const clientApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getClients: build.query<IClient[], void>({
            query: () => "Client",
            providesTags: ["Clients"],
        }),
        getProjectList: build.query<IProject[], number>({
            query: (companyId) => "Project/?companyId=" + companyId,
            providesTags: ["Projects"],
        }),
    }),
})


export { clientApi };